export function getDeclineReasonText(declineReason) {
  if (declineReason == null) return "Not declined";

  switch (declineReason) {
    case "LowIncome":
      return "Low Income";
    case "CreditSafeScoring":
      return "CreditSafe Score";
    case "CreditSafeTaxedIncome":
      return "CreditSafe Taxed Income";
    case "BisnodeHardDecline":
      return "Bisnode Hard Decline";
    case "BisnodeCreditScore":
      return "Bisnode Credit Score";
    case "BisnodeDebt":
      return "Bisnode Debt";
    case "BisnodeAddress":
      return "Bisnode problemat with address";
    case "BisnodeIdentity":
      return "Bisnode problemat with identity";
    case "BisnodePaymentRemarks":
      return "Bisnode payment remarks";
    case "Unemployed":
      return "Unemployed";
    case "Kalp":
      return "Kalp";
    case "NotMainAccount":
      return "Not Main Account";
    case "AllOffersRejected":
      return "Illegible for any offer";
    case "CreditSafeAddress":
      return "CreditSafe problem with address";
    case "KreditzLowIncome":
      return "Kreditz Low Income";
    default:
      return declineReason;
  }
}
